import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import hook from "src/app/hook";
const initialState = {
    users: null,
    modules: null,
    adminUser: null,
    ApiHeader: null,
}

const AdminSlice = createSlice({
    name: "adminUser"
    , initialState,
    reducers: {
        setAdminUser: (state, action) => {
            state.adminUser = action.payload

        },
        setUserModuleAndPermision: (state, action) => {
            state.users = action.payload
        },
        setApiHeader: (state) => {
            // hook.useAxios({ "url": "/api/GetApiHeader", "method": "post", "data": { "loginId": state.adminUser?.adminUserId } })
            state.ApiHeader = action.payload
        }
    },
})
export const { setEditAdmin, setEditLang, ForEditRoleList, setEdit, setAdminUser, setUserModuleAndPermision } = AdminSlice.actions
export default AdminSlice;